import React from 'react';

export const ModalContext = React.createContext({
    onStartInteractionWithChildren: null,
    onEndInteractionWithChildren: null
});
